/**
 * Mixin methods for voicemail folders
 */
import { mapGetters } from 'vuex'

export default {
  name: 'mixin-voicemails-folders',
  computed: {
    ...mapGetters({
      voicemailCustomFolders: 'voicemails/customFolders'
    }),
    customFolders () {
      return this.voicemailCustomFolders.map(customFolder => {
        return {
          text: customFolder,
          name: customFolder,
          icon: 'mdi-folder',
          displayed: true,
          class: 'drawer-btn-customFolder'
        }
      })
    },
    folders () {
      return [...this.staticFolders, ...this.customFolders]
    },
    staticFolders () {
      return [
        {
          text: this.$t('vmail.folder.all'),
          name: null,
          icon: 'mdi-voicemail',
          displayed: true,
          class: 'drawer-btn-all'
        },
        {
          text: this.$t('vmail.folder.inbox'),
          name: 'inbox',
          icon: 'mdi-email',
          displayed: true,
          class: 'drawer-btn-inbox'
        },
        {
          text: this.$t('vmail.folder.old'),
          name: 'old',
          icon: 'mdi-email-open',
          displayed: true,
          class: 'drawer-btn-old'
        },
        {
          text: this.$t('vmail.folder.favorite'),
          name: 'favorite',
          icon: 'mdi-star',
          displayed: true,
          class: 'drawer-btn-favorite'
        }
      ]
    }
  }
}
